import React from 'react';
import T from 'components/T';
import { M } from '@dashboard-experience/mastodon';
import { i18n } from '@international/mastodon-i18n';
import { DisputeArticle } from './ArticleTicket';
import DescribeField from './DescribeField';
import { getSectionDisplayName } from '../lib/screenings';

interface DescribeFormProps {
  article: DisputeArticle;
  section?: string;
  selectedField: (selected: string) => void;
}

const DescribeForm = ({
  article,
  section = '',
  selectedField,
}: DescribeFormProps) => {
  return (
    <div data-testid='describe-form'>
      <div className='cp-form-group'>
        {section && (
          <div data-testid='describe-form-breadcrumb'>
            <span className='text-muted'>
              {getSectionDisplayName(section)} &#62;{' '}
            </span>
            <span>{article.title}</span>
          </div>
        )}
        <span className='form-question'>
          <T value='components.Report.Dispute.DescribeSituation.question' />
        </span>
        <hr />
      </div>
      {article.wrongPersonConfirmation && (
        <M.CardList data-testid='describe-form-ul-wrong-person'>
          <DescribeField
            caption='components.Report.Dispute.DescribeSituation.isNotMine'
            value='reason_wrong_person'
            selectedField={selectedField}
          />
          <DescribeField
            caption='components.Report.Dispute.DescribeSituation.stolenIdentity'
            value='reason_identity_theft'
            selectedField={selectedField}
          />
        </M.CardList>
      )}
      {!article.wrongPersonConfirmation && (
        <M.CardList>
          <DescribeField
            caption='components.Report.Dispute.DescribeSituation.hasChanged'
            value='reason_report_update'
            selectedField={selectedField}
          />
          <DescribeField
            caption='components.Report.Dispute.DescribeSituation.isInaccurate'
            value='reason_inaccurate'
            selectedField={selectedField}
          />
        </M.CardList>
      )}
    </div>
  );
};

export default i18n.renderTranslation()(DescribeForm);
